import React, { Fragment, useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import route from './helper/route';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style/style.scss';
import './i18n';
import { PublicApi } from './api';
import Beneficiary from './pages/Beneficiary';
import { CommonDataProvider } from 'contexts/CommonDataContext/CommonDataProvider';

const publicApi = new PublicApi()

function App() {

  const [countryRoutes,setCountryRoutes] = useState([])

  const getAllCountry = async () => {
    const response = await publicApi.apiPublicGetAllCountry();
   setCountryRoutes(response?.data?.map((country, index) => ({
        path: `/country/${country.name}`, // Assuming `name` exists
        element: <Beneficiary key={country.id} id={country.id} country={country.name} />, // Or any identifier from the API
    })))
    return response;
  }

  useEffect(() => {
    getAllCountry();
  },[])

  return (
    <Fragment>
      <BrowserRouter  future={{
    v7_relativeSplatPath: true,
    v7_startTransition: true,
  }}>
        <Routes>
          {[...route,...countryRoutes]?.map((route, index) => {
            return (
              <Route
                key={index}
                exact
                path={route.path}
                element={<CommonDataProvider>{route.element}</CommonDataProvider>}
              />
            );
          })}
        </Routes>
      </BrowserRouter>
    </Fragment>
  );
}

export default App;
